import Vue from 'vue';
import Element from 'zk-ui';
import i18n from 'common-module/src/lang';

Element.Input.props.clearable.default = function () {
  const getParentName = instance => {
    if (!instance.$parent) {
      return;
    }
    const { name } = instance.$parent.$options;
    return name || getParentName(instance.$parent);
  };
  // 数组中的input不修改默认值
  return !['ElPagination', 'ElDatePicker'].includes(getParentName(this));
};

const checkBlurConfirmButton = async (options) => {
  if (options?.autoFocusConfirmButton !== true) {
    // 等待show
    await Vue.nextTick();
    // 等待focus
    await Vue.nextTick();
    document.activeElement?.blur();
  }
};

Vue.use(Element, {
  size: 'medium', // set element-ui default size,
  i18n: (key, value) => i18n.t(key, value),
  selectedTextFormat: count => i18n.tc('component.selectedCount', count, [count]),
  selectMultipleLimit: 500
});

Vue.prototype.$msgbox = new Proxy(Element.MessageBox, {
  apply(target, thisArg, argArray) {
    const result = Reflect.apply(target, thisArg, argArray);
    checkBlurConfirmButton(argArray[0]).then();
    return result;
  }
});

Vue.prototype.$confirm = function (message, title, options) {
  const result = Reflect.apply(Element.MessageBox.confirm, this, [message, title, options]);
  checkBlurConfirmButton(options).then();
  return result;
};
